import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import Logo from "assets/img/grind-logo.svg";
import ProfileIcon from "assets/icons/profile.svg";
import ChevronDown from "assets/icons/chevron-down.svg";
import ChevronUp from "assets/icons/chevron-up.svg";
import Navbar from "./Navbar";

import styles from "./Header.module.scss";

import { Card } from "react-rainbow-components";
import { submitLogout } from "../auth/actions";

import cx from "classnames";

const UserMenu = ({ user }) => {
    const [showDropdown, setShowDropdown] = useState(false);
    const dispatch = useDispatch();
    const history = useHistory();

    return (
        <div
            className={styles.user}
            onClick={() => setShowDropdown(!showDropdown)}
        >
            <img src={ProfileIcon} alt="Profile icon" />
            <p className={`gkit-p-17 m-0 mx-3 ${styles.userName}`}>
                {user.first_name} {user.last_name}
            </p>
            {showDropdown ? (
                <img src={ChevronUp} alt="Chevron up" width={16} height={16} />
            ) : (
                <img
                    src={ChevronDown}
                    alt="Chevron down"
                    width={16}
                    height={16}
                />
            )}
            {showDropdown && (
                <div className={styles.logoutDropdown}>
                    <Card className={styles.optionsMenu}>
                        <div
                            className="d-flex m-3"
                            onClick={() => history.push("/account")}
                        >
                            <p className="gkit-p-17">Account</p>
                        </div>
                        <div
                            className="d-flex m-3"
                            onClick={() => dispatch(submitLogout())}
                        >
                            <p className="gkit-p-17">Logout</p>
                        </div>
                    </Card>
                </div>
            )}
        </div>
    );
};

const Header = () => {
    const { user, isAdmin, isLoggedIn } = useSelector((s) => s.auth);
    const hasSession =
        isLoggedIn ||
        (isLoggedIn === null && localStorage.getItem("accessToken"));
    return (
        <nav
            className={cx(
                "header w-100",
                hasSession ? "position-sticky top-0" : "position-fixed",
                styles.header,
                !isLoggedIn && styles.transparent,
                isLoggedIn && styles.pink,
            )}
        >
            <div className="container d-flex align-items-center justify-content-center justify-content-md-between position-relative mt-28px">
                <div className={styles.logoAndNav}>
                    <a href="https://grind.co.uk/" className={styles.logo}>
                        <img className="logo" src={Logo} alt="Grind Logo" />
                    </a>
                    <div className={cx(styles.nav, !isLoggedIn && "invisible")}>
                        {hasSession && <Navbar />}
                    </div>
                </div>
                {isAdmin && (
                    <span className="gkit-badge badge gkit-pink ml-3">
                        admin
                    </span>
                )}
                {isLoggedIn && user && <UserMenu user={user} />}
            </div>
        </nav>
    );
};

export default Header;
